import React, { FC } from 'react';
import { SystemManager } from '../../../utils/SystemManager';

const TitularOroTpec: FC = () => {
  return <>{SystemManager.getSystem('tarjeta-titular-oro-tpec')}</>;
};

export default TitularOroTpec;
